import { create } from "zustand";

const useBottomMenuStore = create((set) => ({
  isBottomMenuOpen: false,
  setIsBottomMenuOpen: (isBottomMenuOpen) => set(() => ({ isBottomMenuOpen })),
  activeButton: null,
  setActiveButton: (activeButton) => set(() => ({ activeButton })),
  activeRow: null,
  setActiveRow: (activeRow) => set(() => ({ activeRow })),
  selectedTapNumber: null,
  setSelectedTapNumber: (selectedTapNumber) =>
    set(() => ({ selectedTapNumber })),
}));

export default useBottomMenuStore;
